import { dataService } from '../../data';

import { DataObject, ObjectOptions, RelatedObject } from '../base';
import { CreateObject } from '../item';
import { Rasppi } from './rasppi';

/****************************/
/* SCHEMA DEFINITION        */
/****************************/

import { RasppiType } from '../types';

const _schema = {
    name: 'CODESCAN',
    fields: [
        { name: 'rasppi', type: 'objid' },
        { name: 'status', type: 'string', default: 'AC' },
        { name: 'name', type: 'string' },
    ],
    relate: [
        { direction: '>', target: 'RASPPI', by: 'codescans', name: 'rasppi', reason: 'rasppi', child: false, class: RasppiType },
    ]
} as const;

const _CodescanClass = CreateObject(_schema);
if (!_CodescanClass) {
    throw new Error("Failed to create BaseClass for '" + _schema.name + "'");
}

/****************************/
/* CLASS DECLARATION        */
/****************************/

export class CodescanDevice extends _CodescanClass {
    constructor(objid: string | null, data: dataService, objoptions: ObjectOptions | null = null){
        super(_schema, objid, data, objoptions || {});
    }

    Copy(store: Array<DataObject> = []): CodescanDevice {
        return this._Copy(store) as CodescanDevice;
    }

    protected override DoChildLinked(relation: string | null, related: RelatedObject | null): void {
        if (this.CopyOf || !this.Commited){
            return;
        }

        if (relation === 'codescans' && related instanceof Rasppi){
            if (related === this.rasppi){
                related.AddCodescan(this);
            }
        }
    }

    get status(): string | null {
        return this['__base__status'];
    }

    set status(value: string){
        if (this.status == 'DE'){
            return;
        }

        if (this.status == value){
            return;
        }

        this['__base__status'] = value;
        if (this.rasppi){
            if ((this.status == 'DE') && !this.Commited){
                this.rasppi.DelCodescan(this);
            }
            else {
                this.rasppi.DoRefresh(this.table);
            }
        }
    }

    get IsValid(): boolean {
        return (!!this.status && (this.status != 'DE'));
    }
}
